import { Injectable, signal } from '@angular/core';
import { DocumentService } from './document.service';
import { VisitorService } from './visitor.service';
declare let adsbygoogle: any;

@Injectable({ providedIn: 'root' })
export class AdsenseService {
  _adsUnits = [
    6367980722, 6290053121, 2404716803, 7681062398, 3717798475, 4123054786,
    7603134792, 8916216466, 1515109294, 1307225735, 4560106853, 5454354300,
    1906023357, 6343961819, 5873188527, 2620307405, 8080517647, 9574692010,
    8970125156, 3933389077, 1887773681, 4532186696, 7186270194, 2596288492,
    1229298132, 6749218127, 8062299791, 2542379809, 3855461478, 5382960288,
    5981726086, 5746461361, 1915893536, 8755768087, 6911664371, 2239327168,
    // 'Posty_Unit_2_300_250',
    // 'Posty_Unit_3_728_90',
  ];

  get adUnit() {
    this.checkIfAllowAds();
    return this._adsUnits[Math.floor(Math.random() * this._adsUnits.length)];
  }
  adBlockedIsActive = signal(false);
  constructor(
    private documentService: DocumentService,
    // private visitorService: VisitorService,
  ) {
    if (this.documentService.location.hostname.includes('posty5')) {
      this._adsUnits = [
        6367980722, 6290053121, 2404716803, 7681062398, 3717798475, 4123054786,
        7603134792, 8916216466, 1515109294, 1307225735, 4560106853, 5454354300,
        1906023357, 6343961819, 5873188527, 2620307405, 8080517647, 9574692010,
        8970125156, 3933389077, 1887773681, 4532186696, 7186270194, 2596288492,
        1229298132, 6749218127, 8062299791, 2542379809, 3855461478, 5382960288,
        5981726086, 5746461361, 1915893536, 8755768087, 6911664371, 2239327168,
      ];
    } else {
      this._adsUnits = [
        6414041124, 1052127131, 5100959452, 3787877789, 3895688994,
      ];
    }
    // this.documentService.window?.addEventListener('message', (event: any) => {
    //   if (!this._adsUnits.some((adId) => adId == event.data)) return;
    //   this.visitorService.adClicked(+event.data as any);
    // });
  }

  async checkIfAllowAds() {
    return
    try {
      const request = new Request(
        'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js',
        { method: 'HEAD', mode: 'no-cors' },
      );
      await fetch(request);
    } catch (error) {
      this.adBlockedIsActive.set(true);
    }
  }

  private fixAds(
    ins: HTMLDivElement,
    parent: HTMLDivElement,
    width: string,
    height: string,
  ) {
    if (
      !ins?.hasAttribute('data-ad-status') ||
      ins?.getAttribute('data-ad-status') === 'unfilled' ||
      ins.innerHTML === ''
    ) {
      this.reDrawIns(ins, parent, width, height);
    }
  }

  private reDrawIns(
    ins: HTMLDivElement,
    parent: HTMLDivElement,
    width: string,
    height: string,
  ) {
    try {
      if (height) {
        ins.style.height = height;
      } else {
        ins.style.height = 'auto';
      }
      if (width) {
        ins.style.width = width;
      } else {
        ins.style.width = 'auto';
      }
      //  parent.style.height = height;
      //parent.style.width = width;
      this.documentService.document.body?.removeAttribute('aria-hidden');

      ins.removeAttribute('data-ad-status');
      ins.removeAttribute('data-adsbygoogle-status');
      ins.innerHTML = '';

      setTimeout(() => {
        this.push(ins, parent, width, height);
      }, 1000);
    } catch (error) {
      console.log('reDrawIns error', error);
    }
  }

  push(
    ins: HTMLDivElement,
    parent: HTMLDivElement,
    width: string,
    height: string,
  ) {
    try {
      if (typeof adsbygoogle == 'undefined') {
        throw 'adsbygoogle still not found';
      } else {
        if (!this.adBlockedIsActive()) {
          adsbygoogle.push({});
          //Fix ad
          setTimeout(() => {
            this.fixAds(ins, parent, width, height);
          }, 1000 * 60);
        }
      }
    } catch (error) {
      setTimeout(() => {
        this.push(ins, parent, width, height);
      }, 1000);
    }
  }
}
